import React from "react";
import logo from "../../../assets/images/inc-policy-logo.png";
import imgCustSelect from "../../../assets/images/customers-select.png";

const CustomerOverview = () => {
  return (
    <div>
      <div className="row mb-4">
        <div className="col-lg-12">
          <div className="inc-card">
            <div className="inc-card-title">
              <h3>Customers</h3>
            </div>
            <div className="inc-card-body">
              <h4 className="inc-blue-heading">Customers overview</h4>
              <p>
                A Customer is a separate business entity, individual, or
                organization that purchases or uses tenant devices and assets.
                The Customer may have multiple users and millions of devices and
                assets.
              </p>

              <h4 className="inc-blue-heading">Customers overview</h4>
              <p>
                A Customer is a separate business entity, individual, or
                organization that purchases or uses tenant devices and assets.
                The Customer may have multiple users and millions of devices and
                assets.
              </p>
              <ol>
                <li>
                  A Customer is a separate business entity, individual, or
                  organization that purchases or uses tenant devices and assets.
                  <br />
                  <img src={imgCustSelect} alt="Customer Select" />
                </li>
                <li>
                  A Customer is a separate business entity, individual, or
                  organization that purchases or uses tenant devices and assets.
                </li>
                <li>
                  A Customer is a separate business entity, individual, or
                  organization that purchases or uses tenant devices and assets.
                </li>
              </ol>

              <ul>
                <li>
                  A Customer is a separate business entity, individual, or
                  organization that purchases or uses tenant devices and assets.
                </li>
                <li>
                  A Customer is a separate business entity, individual, or
                  organization that purchases or uses tenant devices and assets.
                </li>
                <li>
                  A Customer is a separate business entity, individual, or
                  organization that purchases or uses tenant devices and assets.
                </li>
              </ul>

              <div className="alert alert-danger" role="alert">
                <h4 className="alert-heading">IMPORTANT:</h4>
                <p>
                  If you delete the Customer, all the data related to this role,
                  as well as the level itself, will be lost.
                </p>
              </div>

              <h4 className="inc-blue-heading">Customers overview</h4>
              <p>
                A Customer is a separate business entity, individual, or
                organization that purchases or uses tenant devices and assets.
                The Customer may have multiple users and millions of devices and
                assets.
              </p>
              <img
                src={imgCustSelect}
                className="helpLicesne-img"
                alt="Customer Overview"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerOverview;
